import { usePage } from "@inertiajs/react";
import { pick } from "../../lib/i18n";
import { formatBytes } from "../../lib/productPresentation";

type StorageAlert = {
  level: "warning" | "blocked";
  percent_used: number;
  percent_free: number;
  free_bytes: number;
};

const copy = {
  pl: {
    warning: (free: string, pct: number) =>
      `Kończy się miejsce na dysku — wolne ${free} (${pct}%). Wyczyść stare generacje lub przełącz storage na S3.`,
    blocked: (pct: number) =>
      `Brak miejsca na dysku (zajęte ${pct}%). Wgrywanie plików i generacje są zablokowane.`,
    manage: "Zarządzaj storage",
  },
  en: {
    warning: (free: string, pct: number) =>
      `Running out of disk space — ${free} free (${pct}%). Clear old generations or switch storage to S3.`,
    blocked: (pct: number) =>
      `No disk space left (${pct}% used). File uploads and generations are blocked.`,
    manage: "Manage storage",
  },
};

export default function StorageBanner() {
  const { storage_alert, current_user } = usePage<{
    storage_alert?: StorageAlert | null;
    current_user?: { role?: string };
  }>().props;

  if (!storage_alert) return null;

  const t       = pick(copy);
  const blocked = storage_alert.level === "blocked";

  const message = blocked
    ? t.blocked(storage_alert.percent_used)
    : t.warning(formatBytes(storage_alert.free_bytes), storage_alert.percent_free);

  const tone = blocked
    ? { background: "oklch(0.62 0.20 25 / 0.10)", border: "oklch(0.62 0.20 25 / 0.35)", color: "var(--danger)" }
    : { background: "oklch(0.78 0.16 75 / 0.12)", border: "oklch(0.78 0.16 75 / 0.40)", color: "var(--ink)" };

  return (
    <div
      role="status"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        margin: "12px 24px 0",
        padding: "8px 12px",
        borderRadius: "var(--radius)",
        background: tone.background,
        border: `1px solid ${tone.border}`,
        color: tone.color,
        fontSize: 12.5,
      }}
    >
      <span>{message}</span>
      {current_user?.role === "admin" && (
        <a href="/admin/storage" className="btn btn-sm" style={{ flexShrink: 0 }}>
          {t.manage}
        </a>
      )}
    </div>
  );
}
